/*  MUI  */
import { Grid, Paper, Tab } from '@mui/material';

/* Shared */
import { PageTitle } from 'application/Shared/Components/App';
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';
import { Route } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

/*  Pages  */
import Branding from './Pages/Containers/Branding';
import Settings from './Pages/Containers/Settings';

export const HubSettings = () => {
    const { t } = useTranslation();
    const { partnerId, tab } = useParams();
    const activeTab = tab ?? 'branding';

    const basePartnerRoute = Route.buildBasePartnerRoute({ partnerId });

    return (
        <>
            <PageTitle title={t('Common.hub_settings')} />
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <MUITabsWrapper value={activeTab}>
                        <Tab
                            component={Link}
                            to={`${basePartnerRoute}/hubSettings/branding`}
                            value="branding"
                            label={t('Common.branding')}
                        />
                        <Tab
                            component={Link}
                            to={`${basePartnerRoute}/hubSettings/settings`}
                            value="settings"
                            label={t('Common.settings')}
                        />
                    </MUITabsWrapper>
                </Grid>
            </Grid>

            <Paper elevation={0} variant="outlined">
                {activeTab === 'branding' && <Branding />}
                {activeTab === 'settings' && <Settings />}
            </Paper>
        </>
    );
};
